import { render, staticRenderFns } from "./modifyUserInfo.vue?vue&type=template&id=46b45be0&scoped=true&"
import script from "./modifyUserInfo.vue?vue&type=script&lang=js&"
export * from "./modifyUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./modifyUserInfo.vue?vue&type=style&index=0&id=46b45be0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b45be0",
  null
  
)

export default component.exports